import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VMenu, _vm._b({
    attrs: {
      "bottom": "",
      "left": "",
      "close-on-click": true,
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn, _vm._g(_vm._b({
          staticClass: "mt-2 mb-1",
          attrs: {
            "small": "",
            "text": "",
            "color": _vm.color
          }
        }, 'v-btn', attrs, false), on), [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.columns')) + "\n      "), _c(VIcon, {
          staticClass: "ml-1",
          attrs: {
            "small": "",
            "color": _vm.color
          }
        }, [_vm._v("fal fa-angle-down")])], 1)];
      }
    }])
  }, 'v-menu', {
    ..._vm.$attrs
  }, false), [_c(VList, {
    attrs: {
      "dense": ""
    }
  }, [_c(VListItemGroup, {
    attrs: {
      "multiple": "",
      "color": _vm.color
    },
    model: {
      value: _vm.activeIndexes,
      callback: function ($$v) {
        _vm.activeIndexes = $$v;
      },
      expression: "activeIndexes"
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c(VListItem, {
      key: index,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function ({
          active
        }) {
          return [_c(VListItemAction, [_c(VCheckbox, {
            attrs: {
              "dense": "",
              "color": _vm.color,
              "input-value": active
            }
          })], 1), _c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])], 1)];
        }
      }], null, true)
    });
  }), 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };